<template>
  <b-card class="assets-and-maneuver">
    <b-container fluid >
      <b-row>
        <filters
          :filterBackup="filterBackup"
          :maneuvers="value"
          :modules="modules"
          :no-maneuver-selected="!value.length"
          :installation-filter="installationFilter"
          :loading="loading"
          @search="getManeuvers"
          @get-modules="getModules"
          @clear-grid="clearGrid"
          @handle-assets="handleAssets"
          @save-filter-options="saveFilterBackup"
          @initialize-references="initializeReferences"
        />
      </b-row>
      <b-row>
        <label>
          {{ $t('reports.add-maneuvers') }}*
        </label>
        <grid
          v-if="assetsReader"
          :filterBackup="filterBackup"
          :backup="selectedBackup"
          :items="maneuversList"
          :loading="loading"
          :maxLimitOfManeuvers="MAX_MANEUVER_LIMIT"
          :activeManeuvers="activeManeuvers.length"
          @input="selectManeuvers"
          @updateManeuverList="updateManeuverList"
          @addActiveManeuvers="addActiveManeuvers"
          @removeActiveManeuvers="removeActiveManeuvers"
        />
        <b-col v-else cols="12" align-self="center" class="mt-5">
          <s-loader size="lg"/>
        </b-col>
      </b-row>
      <b-row class="mt-3" align-h="end">
        <b-col
          sm="12"
          md="auto"
          class="my-3 my-md-0"
        >
          <b-button
            class="advanced-settings-button"
            variant="outline-primary"
            size="sm"
            :disabled="activeButtonAdvancedSettings"
            @click="openModalVariables"
          >
            <span class="rounded-circle material-icons mr-3">settings</span>
            {{ $t('fields.asset.advanced-settings') }}
          </b-button>
        </b-col>
      </b-row>
      <variables-and-reference-modal
        slot="content:variables-and-reference"
        :show-modal="showModal"
        :assetTypeId="assetType"
        :maneuverType="maneuverTypes"
        :moduloId="moduloId"
        :backup="backup"
        @references-changed="updateReferenceVariables"
        @variables-changed="updateVariablesIds"
        @close-modal="closeModalVariables"
        @save="addCustomVariables"
      />
    </b-container>
  </b-card>
</template>
<style lang="sass" scoped>
  .assets-and-maneuver
    background-color: var(--color-background-regular)
</style>

<script>
import Filters from '@/domain/components/generalPanel/reports/oscillography/newReport/assetAndManeuver/Filters';
import Grid from '@/domain/components/generalPanel/reports/oscillography/newReport/assetAndManeuver/Grid';
import MAX_MANEUVER_LIMIT from '@/domain/constants/reports/oscillography';
import VariablesAndReferenceModal from '../variablesAndReferenceModal';

export default {
  name: 'AssetAndManeuver',
  components: {
    Filters,
    Grid,
    VariablesAndReferenceModal,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    selectedBackup: {
      type: Array,
    },
    installationFilter: {
      type: Array,
    },
    modules: {
      type: Array,
    },
    maneuversList: {
      type: Array,
    },
    filterBackup: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
    },
    backup: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    assetsReader: false,
    payload: {},
    showModal: false,
    assetType: '',
    maneuverTypes: [],
    moduloId: '',
    activeManeuvers: [],
    MAX_MANEUVER_LIMIT,
  }),
  computed: {
    activeButtonAdvancedSettings() {
      if (this.filterBackup.assetType === '' || this.filterBackup.assets?.length === 0
        || this.filterBackup.maneuverTypes?.length === 0
      ) {
        return true;
      }

      return false;
    },
  },
  methods: {
    clearGrid() {
      this.$emit('clear-grid');
    },
    handleAssets(assets) {
      const assetIds = assets.map(({ id }) => id);
      const filteredSelection = this.selectedBackup
        .filter(({ assetId }) => assetIds.includes(assetId));
      this.selectManeuvers(filteredSelection);
      this.activeManeuvers = filteredSelection;
      this.assetsReader = true;
    },
    getModules(ativosIds) {
      this.$emit('get-modules', ativosIds);
    },
    getManeuvers(filter, activeManeuvers) {
      this.$emit('get-maneuvers', filter, activeManeuvers);
    },
    saveFilterBackup(filter) {
      this.$emit('save-filter-backup', filter);
    },
    selectManeuvers(value) {
      this.$emit('input', value);
    },
    addActiveManeuvers(maneuvers) {
      this.activeManeuvers = maneuvers;
    },
    removeActiveManeuvers(value) {
      const hasRegisteredOscillographs = this.filterBackup.registeredOscillographs;
      this.activeManeuvers = this.activeManeuvers
        .flat()
        .filter(maneuver => maneuver.oscillographyId !== value.oscillographyId);

      if (hasRegisteredOscillographs && hasRegisteredOscillographs.length > 0) {
        this.filterBackup.registeredOscillographs = this.filterBackup.registeredOscillographs
          .filter(({ oscillographyId }) => oscillographyId !== value.oscillographyId);
      }
    },
    updateManeuverList() {
      const activeManeuversIds = this.activeManeuvers
        .flat().map(maneuver => maneuver.oscillographyId);
      this.$emit('get-maneuvers', {
        ...this.filterBackup,
        registeredOscillographs: this.filterBackup.registeredOscillographs
          .filter(({ oscillographyId }) => !activeManeuversIds.includes(oscillographyId)),
      }, activeManeuversIds);
    },
    openModalVariables() {
      this.assetType = this.filterBackup.assetType;
      this.maneuverTypes = this.filterBackup.maneuverTypes;
      this.moduloId = this.filterBackup.modules && this.filterBackup.modules.length > 0
        ? this.filterBackup.modules[0]
        : '';
      this.showModal = true;
    },
    closeModalVariables() {
      this.showModal = false;
    },
    updateReferenceVariables(newItems) {
      this.$emit('get-references', newItems);
    },
    updateVariablesIds(newItems) {
      this.$emit('get-variables', newItems);
    },
    addCustomVariables() {
      this.$pushAlert({ code: 'MS006' });
    },
    initializeReferences(filter) {
      this.assetType = filter.assetType;
      this.maneuverTypes = filter.maneuverTypes;
      this.moduloId = filter.modules && filter.modules.length > 0
        ? filter.modules[0]
        : '';

      if (this.assetType && this.maneuverTypes?.length > 0 && this.moduloId !== '') {
        this.$emit('initialize-references', {
          assetType: this.assetType,
          maneuverTypes: this.maneuverTypes,
          moduloId: this.moduloId,
        });
      }
    },
  },
};
</script>
